import React from 'react';
import {
  VStack,
  Heading,
  Text,
  Button,
  useColorModeValue,
} from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { useOnboardingFlow } from '../../../hooks/onboarding/useOnboardingFlow';
import { useAnalyticsContext } from '../../../contexts/AnalyticsContext';

const WelcomeStep: React.FC = () => {
  const { goNext } = useOnboardingFlow();
  const { trackEvent } = useAnalyticsContext();
  
  const headingGradient = useColorModeValue(
    'linear(to-r, blue.600, purple.600)',
    'linear(to-r, blue.400, purple.400)'
  );
  const textColor = useColorModeValue('gray.600', 'gray.300');
  const buttonBg = useColorModeValue('blue.500', 'blue.400');
  const buttonHoverBg = useColorModeValue('blue.600', 'blue.500');

  const handleGetStarted = () => {
    trackEvent('onboarding_get_started_clicked', {
      timestamp: new Date().toISOString()
    });
    goNext();
  };

  return (
    <VStack spacing={6} align="center" justify="center" h="full">
      <VStack spacing={4}>
        <Heading
          size="3xl"
          bgGradient={headingGradient}
          bgClip="text"
          fontWeight="bold"
          textAlign="center"
        >
          Welcome to LearnYourself
        </Heading>
        
        <Text fontSize="xl" color={textColor} textAlign="center">
          Let's personalize your learning experience
        </Text>
      </VStack>
      
      <Button
        size="lg"
        bg={buttonBg}
        color="white"
        _hover={{ 
          bg: buttonHoverBg,
          transform: 'translateY(-2px)',
          boxShadow: 'xl'
        }}
        _active={{
          transform: 'translateY(0)',
          boxShadow: 'md'
        }}
        onClick={handleGetStarted}
        px={10}
        py={7}
        fontSize="md"
        fontWeight="medium"
        mt={14}
        borderRadius="full"
        boxShadow="lg"
        transition="all 0.2s"
        rightIcon={<ArrowForwardIcon />}
      >
        Get Started
      </Button>
    </VStack>
  );
};

export default WelcomeStep;